import { Fragment } from "react";
import style from "./ExternalFactor.module.css";
import { Table } from "react-bootstrap";
import backendUrl from "../../../../../utilities/backendUrl";
import Barcode from "react-barcode";
import { Link } from "react-router-dom";

function ExternalFactor({ items = [] }) {
  return (
    <Fragment>
      {items.map((item, idx) => {
        const shipment = item.item;
        const source = item.item.source;
        const destination = item.item.destination;

        return (
          <div className="pt-3 pb-5" key={idx}>
            {shipment.external_orders.map((part, number) => (
              <div
                key={number}
                className="p-3 d-flex flex-column align-items-center overflow-x-auto"
              >
                <div className={style.container}>
                  <div
                    className={
                      "d-flex justify-content-between align-items-center " +
                      style.header
                    }
                  >
                    <img className={style.logo} src="/logoTemp.png" alt="" />
                    <div className={style.info}>
                      <p>شرکت واسط اینترنتی: شرکت پیشرو ترابر مهیار شرق</p>
                      <p>نشان اینترنتی شرکت: www.avaex.ir</p>
                      <p>آدرس ایمیل شرکت: pishrotarabar@yahoo.com</p>
                      <p>
                        <span>تلفن تماس واحد پشتیبانی: </span>
                        <span className="d-inline-flex rtl-dir">
                          021-82802466
                        </span>
                      </p>
                    </div>
                    <div className={style.componyLogo}>
                      <img src={item.componyservice.componyImage} alt="" />
                    </div>
                  </div>

                  <div className="d-flex justify-content-between mt-2">
                    <div
                      className={
                        "w-49 border border-1 border-dark p-2 " +
                        style.AddressParag
                      }
                    >
                      <h6>آدرس مبدا (فرستنده)</h6>
                      <p>
                        <span>نام: </span>
                        <span>
                          {source.compony
                            ? source.compony
                            : source.name + " " + source.family}
                        </span>
                        <span> کشور: </span>
                        <span>ایران</span>
                        <span> استان: </span>
                        <span>{source.province.faName}</span>
                        <span> شهر: </span>
                        <span>{source.city.faName}</span>
                      </p>
                      <p>
                        <span>آدرس: </span>
                        <span>{source.address}</span>
                      </p>
                      <p>
                        <span>موبایل: </span>
                        <span>{source.phone}</span>
                        <span>کدپستی: </span>
                        <span>{source.postCode}</span>
                      </p>
                    </div>
                    <div
                      className={
                        "w-49 border border-1 border-dark p-2 " +
                        style.AddressParag
                      }
                    >
                      <h6>آدرس مقصد (گیرنده)</h6>
                      <p>
                        <span>نام: </span>
                        <span>
                          {destination.compony
                            ? destination.compony
                            : destination.name + " " + destination.family}
                          &nbsp;
                        </span>
                        <span> کشور: </span>
                        <span>{destination.country.faName} </span>

                        <span>شهر: </span>
                        <span>{destination.address_external.fa_city_name}</span>
                      </p>
                      <p>
                        <span>آدرس: </span>
                        <span>{destination.address}</span>
                      </p>
                      <p>
                        <span>موبایل: </span>
                        <span>{destination.phone}</span>
                        <span>تلفن: </span>
                        <span>{destination.tel}</span>
                        <span>ایمیل: </span>
                        <span>{destination.email}</span>
                        <span>کدپستی: </span>
                        <span>{destination.postCode}</span>
                      </p>
                    </div>
                  </div>

                  <div
                    className={
                      "border border-1 border-dark p-2 mt-3 " +
                      style.ltr +
                      " " +
                      style.AddressParagLTR
                    }
                  >
                    <h6>Address Destination (receiver)</h6>
                    <p>
                      <span>Name: </span>
                      <span>
                        {destination.address_external.company
                          ? destination.address_external.company
                          : destination.address_external.name +
                            " " +
                            destination.address_external.family}
                      </span>
                      <span>Country: </span>
                      <span> {destination.country.enName}</span>
                      <span>City: </span>
                      <span> {destination.address_external.en_city_name}</span>
                    </p>
                    <p>
                      <span>Address: </span>
                      <span> {destination.address_external.address}</span>
                    </p>
                    <p>
                      <span>Cell Phone: </span>
                      <span> {destination.phone}</span>
                      <span>Email: </span>
                      <span> {destination.email}</span>
                      <span>Postal Code</span>
                      <span> {destination.postCode}</span>
                    </p>
                  </div>

                  <Table bordered={true} className="mt-3">
                    <thead>
                      <tr>
                        <th>ردیف</th>
                        <th>نام محصول</th>
                        <th>تعداد</th>
                        <th>قیمت واحد(ریال)</th>
                        <th>تخفیف(ریال)</th>
                        <th>مجموع(ریال)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>{part.shipment}</td>
                        <td>1</td>
                        <td>
                          {Math.round(
                            shipment.realPayable / shipment.totalNumber
                          ).toLocaleString()}
                        </td>
                        <td>0</td>
                        <td>
                          {Math.round(
                            shipment.realPayable / shipment.totalNumber
                          ).toLocaleString()}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={3}>
                          <span>ارزش اظهار شده کالا: </span>
                          <span>
                            {typeof part.value === "number"
                              ? part.value.toLocaleString()
                              : part.value}
                          </span>
                          <span> ریال</span>
                        </td>
                        <td>
                          <span>ابعاد:&nbsp;</span>
                          <span>{part.height}</span>&nbsp;×
                          <span> {part.length}</span>&nbsp;×
                          <span> {part.width}</span>
                        </td>
                        <td colSpan={2}>
                          <span>برند: </span>
                          <span>{part.brand}</span>
                        </td>
                      </tr>
                    </tbody>
                  </Table>

                  <div className={style.imgGrid}>
                    <h6>تصاویر:</h6>
                    <div className={style.imgBox}>
                      {part.files.map((item, idx) => (
                        <img
                          className={style.img}
                          key={idx}
                          src={backendUrl + "/" + item.path}
                        />
                      ))}
                    </div>
                  </div>

                  <div className="d-flex justify-content-between mt-2 column-gap-2">
                    <div
                      style={{
                        border: "1px solid black",
                        padding: "3px",
                      }}
                    >
                      <p style={{ textAlign: "right" }}>
                        <strong>علت برگشتی:</strong>
                      </p>

                      <div className="d-flex justify-content-between">
                        <div className={"w-50 " + style.inputRow}>
                          <div>
                            <input type="checkbox" name="" id="" />
                            <span>عدم اطلاع از سفارش</span>
                          </div>
                          <div>
                            <input type="checkbox" name="" id="" />
                            <span>عدم وجود وجه نقد/کارت بانکی</span>
                          </div>
                          <div>
                            <input type="checkbox" name="" id="" />
                            <span>درخواست بازگشایی</span>
                          </div>
                          <div>
                            <input type="checkbox" name="" id="" />
                            <span>انصراف از خرید</span>
                          </div>
                          <div>
                            <input type="checkbox" name="" id="" />
                            <span>سفارش تکراری</span>
                          </div>
                        </div>

                        <div className={"w-50 " + style.inputRow}>
                          <div>
                            <input type="checkbox" name="" id="" />
                            <span>نقل مکان</span>
                          </div>
                          <div>
                            <input type="checkbox" name="" id="" />
                            <span>مغایرت مبلغ فاکتور</span>
                          </div>
                          <div>
                            <input type="checkbox" name="" id="" />
                            <span>تاخیر در ارسال سفارش</span>
                          </div>
                          <div>
                            <input type="checkbox" name="" id="" />
                            <span>گیرنده شناخته نشد</span>
                          </div>
                          <div>
                            <input type="checkbox" name="" id="" />
                            <span>سایر موارد:...</span>
                          </div>
                        </div>
                      </div>

                      <p style={{ textAlign: "right" }}>
                        <strong>نام و نام خانوادگی و امضا:</strong>
                      </p>
                    </div>

                    <div className="d-flex justify-content-between flex-grow-1 border border-1 border-black p-2">
                      {shipment.factorstatus === 1 && (
                        <div className={style.rotateBarcode}>
                          <Barcode
                            value={shipment.numberParcel}
                            textAlign="center"
                            displayValue={true}
                            width={1.75}
                            height={50}
                          />
                        </div>
                      )}
                      <div>
                        <div className="text-center">
                          <img
                            src={item.componyservice.componyImage}
                            alt=""
                            className={style.tableImg}
                          />
                          <p>{item.componyservice.compony}</p>
                        </div>

                        <p className="text-center mb-0">
                          <span>نوع ارسال: </span>
                          <span>{item.componyservice.service}</span>
                          <span> - </span>
                          <span>{item.componyservice.componytype}</span>
                        </p>
                        <Table bordered={true} className={style.secondTable}>
                          <tbody>
                            <tr>
                              <td colSpan={2}>
                                <span>مبدا: </span>
                                <span>ایران</span>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <span>مقصد: </span>
                                <span>{destination.country.faName}</span>
                              </td>
                              <td>
                                <span>وزن: </span>
                                <span>{part.weight * 1000}</span>
                                <span> گرم</span>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <span>تاریخ: </span>
                                <span>{item.date}</span>
                              </td>
                              <td>
                                <span>زمان: </span>
                                <span>{item.time}</span>
                              </td>
                            </tr>
                          </tbody>
                        </Table>

                        {shipment.factorstatus === 1 && (
                          <div className="text-center">
                            <Barcode
                              value={shipment.numberParcel}
                              textAlign="center"
                              displayValue={true}
                              width={1.75}
                              height={50}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            <div className={"container " + style.rtl + " " + style.documentBox}>
              <h6>مدارک</h6>
              <ul>
                {shipment.documnets.map((doc, idx) => (
                  <li key={idx}>
                    <Link
                      to={backendUrl + "/" + doc.path}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span>مدرک </span>
                      <span>{idx + 1}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        );
      })}
    </Fragment>
  );
}

export default ExternalFactor;
